import { FT, Tween } from 'ft'
import { Container } from 'pixi.js'
import randomNumber from '@m31271n/random-number'
import store from '#/store'
import Subtitle from './Subtitle'

class SubtitlePlayer extends Container {
  constructor() {
    super()

    if (store.friends.length === 0) return

    if (FT.stage.bounds.height / FT.stage.bounds.width > 1.65) {
      this.tracks = [
        { empty: true, y: 100 },
        { empty: true, y: 240 },
        { empty: true, y: 380 },
      ]
    } else {
      this.tracks = [{ empty: true, y: 150 }, { empty: true, y: 290 }]
    }

    this.subtitles = []
    store.friends.forEach(friend => {
      const { name, temp } = friend

      const subtitle = new Subtitle(name, temp)
      subtitle.state = 'stopped'
      subtitle._name = name
      subtitle._temp = temp

      this.subtitles.push(subtitle)
    })

    const syncFriends = () => {
      store.friends.forEach(friend => {
        const { name, temp } = friend

        const exist = this.subtitles.find(
          subtitle => subtitle._name === name && subtitle._temp === temp
        )

        if (!exist) {
          const subtitle = new Subtitle(name, temp)
          subtitle.state = 'stopped'
          subtitle._name = name
          subtitle._temp = temp
          this.subtitles.push(subtitle)
        }
      })
    }

    const queue = []

    const generator = () => {
      for (const subtitle of this.subtitles) {
        if (subtitle.state === 'stopped') {
          subtitle.state = 'queued'
          queue.push(subtitle)
        }
      }
    }

    const consumer = () => {
      const track = this.tracks.find(t => t.empty)

      if (track?.empty) {
        const item = queue.splice(0, 1)
        const subtitle = item[0]

        if (subtitle) {
          track.empty = false
          subtitle.state = 'playing'

          this.moveSubtitle(subtitle, track, () => {
            track.empty = true
            subtitle.state = 'played'
          })
        }
      }
    }

    const reseter = () => {
      if (this.subtitles.every(subtitle => subtitle.state === 'played')) {
        this.subtitles.forEach(subtitle => {
          subtitle.state = 'stopped'
        })
      }
    }

    FT.ticker.add(syncFriends)
    FT.ticker.add(generator)
    FT.ticker.add(consumer)
    FT.ticker.add(reseter)
  }

  moveSubtitle(subtitle, track, onComplete) {
    const sX = FT.stage.bounds.width
    const dX = -subtitle.width
    subtitle.position.set(sX, track.y)

    const duration = randomNumber({
      min: 6000,
      max: 10000,
      includeMax: true,
    })

    const tween = new Tween(subtitle).to({ x: dX }, duration)
    if (onComplete) {
      tween.onComplete(() => {
        onComplete()
        subtitle.parent.removeChild(subtitle)
      })
    }
    tween.start()

    this.addChild(subtitle)
  }
}

export default SubtitlePlayer
